<template>
  <div id="dashboard-patrol">
    <!-- Table Container Card -->
    <b-card
      no-body
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Entries</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
            <b-button
              v-if="$can('create', 'monitoring_role')"
              variant="primary"
              :to="{ name: 'settings-roles-create'}"
              class="mr-2"
            >
              <span class="text-nowrap">Create</span>
            </b-button>
          </b-col>
          <!-- Search -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <div>
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="refRoleListTable"
        :items="dataRoles"
        responsive
        :fields="tableColumns"
        :filter="searchQuery"
        :sort-by.sync="sortBy"
        striped
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
      >
        <template #cell(actions)="data">
          <b-button
            v-if="$can('edit', 'monitoring_role')"
            variant="primary"
            :to="{ name: 'settings-roles-edit', params: { id: data.item.id } }"
            class="mr-2"
          >
            <span class="text-nowrap">Edit</span>
          </b-button>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRoles"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BPagination, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  onUnmounted, ref, watch, computed,
} from '@vue/composition-api'
import store from '@/store'
import roleStoreModule from '@/views/apps/settings/roles/roleStoreModule'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BButton,

    vSelect,
  },
  methods: {
  },
  setup() {
    const AREA_APP_STORE_MODULE_NAME = 'app-role'

    // Register module
    if (!store.hasModule(AREA_APP_STORE_MODULE_NAME)) store.registerModule(AREA_APP_STORE_MODULE_NAME, roleStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(AREA_APP_STORE_MODULE_NAME)) store.unregisterModule(AREA_APP_STORE_MODULE_NAME)
    })

    // Table Handlers
    const tableColumns = [
      { key: 'name', label: 'Role Name', sortable: true },
      { key: 'modified_by', label: 'last modified by', sortable: true },
      { key: 'modified_at', label: 'last modified date', sortable: true },
      { key: 'actions' },
    ]

    // Use toast
    const toast = useToast()

    const refRoleListTable = ref(null)
    const dataRoles = ref(null)

    const perPage = ref(10)
    const totalRoles = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
      const localItemsCount = refRoleListTable.value ? refRoleListTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalRoles.value,
      }
    })

    const refetchData = () => {
      fetchRoles()
      refRoleListTable.value.refresh()
    }

    watch([currentPage, perPage], () => {
      refetchData()
    })

    const fetchRoles = (ctx, callback) => {
      store
        .dispatch('app-role/fetchRoles', {
          // q: searchQuery.value,
          perPage: perPage.value,
          currentPage: currentPage.value,
          // sortBy: sortBy.value,
          // sortDesc: isSortDirDesc.value,
          // status: statusFilter.value,
        })
        .then(response => {
          console.log('ini app rea')
          console.log(response.data.data)
          // const data = response.data.data.list
          // callback(data)
          dataRoles.value = response.data.data.list
          totalRoles.value = response.data.data.total
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching role list',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    fetchRoles()

    return {
      dataRoles,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refRoleListTable,
      totalRoles,

      refetchData,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
